import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_OL_DEACTIVATION } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolDeactivationState extends EntityState<IID_OL_DEACTIVATION, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OLO_DEACTIVATION })
@InterfaceDataStore(InterfaceName.OLO_DEACTIVATION)
export class IIDolDeactivationStore extends EntityStore<IIDolDeactivationState> {
  constructor() {
    super([]);
  }
}
